import React from "react";

import SignIn from "../features/auth/SignIn";

function SignInPage() {
  return <SignIn />;
}

export default SignInPage;
